import { Checkbox, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

interface HeaderProps {
  onExport: () => void;
  editable: boolean;
  onEditableChange: (editable: boolean) => void;
  isEditableVisible?: boolean;
  isDisabled?: boolean;
}

export const Header = ({
  onExport,
  editable,
  onEditableChange,
  isEditableVisible = true,
  isDisabled = false
}: HeaderProps) => {
  return (
    <div className="canvas-header">
      <h1 className="canvas-title">Editor</h1>
      <div className="header-controls">
        {isEditableVisible && (
          <Checkbox checked={editable} onChange={(e) => onEditableChange(e.target.checked)} style={{ color: 'white' }}>
            Editable
          </Checkbox>
        )}
        <Button
          disabled={isDisabled}
          onClick={onExport}
          className="border-none !text-black shadow-lg"
          title="Save as Word Document"
          icon={<SaveOutlined />}
        >
          Save as Word
        </Button>
      </div>
    </div>
  );
};
